import qs from 'qs';
import { newAPI, changeBaseNewAPI } from '../../../services';

export const fetchProfile = async userId => {
  const response = await newAPI.get(`/user/${userId}`);
  return response.data;
}

export const createNewUser = async params => {
  const response = await changeBaseNewAPI('post', '/user/new', qs.stringify(params));
  return response.data;
}

export const updateUser = async params => {
  const { userId } = params;

  const response = await newAPI.put(`/user/${userId}`, qs.stringify(params));
  return response.data;
}

export const requestUpdateUserPassword = async (userId, params) => {
  const response = await newAPI.put(`/user/${userId}/update-password`, qs.stringify(params));
  return response.data;
}

export const consultNewPasswordTerms = async userId => {
  const response = await newAPI.get(`${userId}/consult-new-password-terms`);
  return response.data;
}

export const consultUserNewPasswordTerms = async userId => {
  const response = await newAPI.get(`${userId}/consult-user-new-password-terms`);
  return response.data;
}

export const requestResetUserPassword = async (userId, params) => {
  const response = await newAPI.post(`${userId}/password-reset`, qs.stringify(params));
  return response.data;
}

export const fetchMfa = async userId => {
  const response = await newAPI.get(`/${userId}/security`);
  return response.data;
}

export const updateEnableMfa = async userId => {
  const response = await newAPI.post(`/${userId}/security/email-2fa/enable`);
  return response.data;
}

export const updateEnableMfaConfirm = async (userId, code) => {
  const response = await newAPI.post(`/${userId}/security/email-2fa/enable/confirm`, qs.stringify({ code }));
  return response.data;
}

export const updateDisableMfa = async userId => {
  const response = await newAPI.post(`/${userId}/security/email-2fa/disable`);
  return response.data;
}

export const updateDisableMfaConfirm = async (userId, code) => {
  const response = await newAPI.post(`/${userId}/security/email-2fa/disable/confirm`, qs.stringify({ code }));
  return response.data;
}